import template from './aolSilentLogin.template.html';

export default {
  template,
  controller: class controller {
    constructor($rootScope, $mdDialog, $window, $mdMedia, lodgementService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.url = null;
      ctrl.isLoading = false;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Home loan ~ AOL Silent Login
       * --------------------------------------------------------------------------------
       */
      this.aolSilentLogin = () => {
        if (!ctrl.url) {
          ctrl.isLoading = true;
          lodgementService.applyOnlineSilentLogin().then((result) => {
            ctrl.url = result.url;
            ctrl.isLoading = false;
          });
        } else {
          $window.open(ctrl.url, '_blank', '');
          ctrl.url = '';
        }
      };
    }
  }
};
